export default function({ state, commit, dispatch }, query) {
    commit('startLoadingPatient', query.id)

    return dispatch('get', {
        url: '/provider/' + state.id + '/patient/' + query.id + '/message',
        query
    }, {
        root: true
    })
    .then((response) => {
        commit('finishLoadingPatient', query.id)
        commit('setPatientMessages', response)
    })
    .catch((error) => {
        commit('finishLoadingPatient', query.id)
        throw error
    })
}
